/**
 * @owner shared — infra
 * REFACTOR: Simplified loading store that delegates to React Query
 * React Query handles all HTTP request loading states automatically
 * This store only handles non-query loading (auth, components, etc.)
 */

import { create } from "zustand";

export type LoadingKey =
  | "bootstrap"  // Auth loading
  | "components" // Component-specific loading
  | `custom:${string}`;

interface LoadingState {
  busy: Set<LoadingKey>;
  start: (key: LoadingKey) => void;
  stop: (key: LoadingKey) => void;
  isAnyLoading: () => boolean;
  reset: () => void;
  getActiveKeys: () => LoadingKey[];
}

export const useLoadingStore = create<LoadingState>()((set, get) => ({
  busy: new Set<LoadingKey>(),

  start: (key) => set((s) => ({ busy: new Set([...s.busy, key]) })),

  stop: (key) => set((s) => {
    const next = new Set(s.busy);
    next.delete(key);
    return { busy: next };
  }),


  reset: () => set({ busy: new Set<LoadingKey>() }),

  isAnyLoading: () => get().busy.size > 0,

  getActiveKeys: () => Array.from(get().busy),
}));
